export default __webpack_public_path__ + "locales/el-GR/Translations.json?hash=b3d1f77467c3e8989735323dd71a2a6f";